(function(scope){
'use strict';
const catalog = {
  "schema_version": 1,
  "view_convention": "Wearer left/right; never mirror a side image. Front is straight-on.",
  "rights_note": "AS Colour public product resources used for supplier-product illustration; not Waves work. Zapped/OTTO reuse permission not verified; no such images activated.",
  "models": {
    "foam_premium_solid": {
      "style": "foam",
      "manufacturer": "AS Colour",
      "reference": "1161",
      "construction": "five-panel foam-front mesh-back trucker",
      "source_page": "https://ascolour.com/frame-foam-trucker-cap-1161/",
      "areas": {},
      "colors": {
        "black": {
          "name": "Black",
          "catalog_verified": true,
          "stock_verified": false,
          "supplier_variant_id": null,
          "views": {
            "front": {
              "verified": true,
              "view": "front",
              "source": "https://cdn11.bigcommerce.com/s-hsi95a83fz/images/stencil/500w/products/656/16052/1161_FRAME_TRUCKER_CAP_BLACK__69107.1716785064.jpg?c=1",
              "srcset": [
                {
                  "width": 500,
                  "url": "https://cdn11.bigcommerce.com/s-hsi95a83fz/images/stencil/500w/products/656/16052/1161_FRAME_TRUCKER_CAP_BLACK__69107.1716785064.jpg?c=1"
                },
                {
                  "width": 1000,
                  "url": "https://cdn11.bigcommerce.com/s-hsi95a83fz/images/stencil/1000w/products/656/16052/1161_FRAME_TRUCKER_CAP_BLACK__69107.1716785064.jpg?c=1"
                }
              ],
              "width": 500,
              "height": 500,
              "alt": "AS Colour 1161, Black, straight-on front",
              "area_id": null,
              "usage_basis": "AS Colour public product-image resources; guidelines reviewed; no transfer of ownership"
            },
            "left": null,
            "right": null,
            "back": {
              "verified": true,
              "view": "back",
              "source": "https://cdn11.bigcommerce.com/s-hsi95a83fz/images/stencil/500w/products/656/16058/1161_FRAME_TRUCKER_CAP_BLACK_BACK__81556.1717123262.jpg?c=1",
              "srcset": [
                {
                  "width": 500,
                  "url": "https://cdn11.bigcommerce.com/s-hsi95a83fz/images/stencil/500w/products/656/16058/1161_FRAME_TRUCKER_CAP_BLACK_BACK__81556.1717123262.jpg?c=1"
                },
                {
                  "width": 1000,
                  "url": "https://cdn11.bigcommerce.com/s-hsi95a83fz/images/stencil/1000w/products/656/16058/1161_FRAME_TRUCKER_CAP_BLACK_BACK__81556.1717123262.jpg?c=1"
                }
              ],
              "width": 500,
              "height": 500,
              "alt": "AS Colour 1161, Black, rear view showing snapback closure",
              "area_id": null,
              "usage_basis": "AS Colour public product-image resources; guidelines reviewed; no transfer of ownership"
            }
          }
        },
        "navy": {
          "name": "Navy",
          "catalog_verified": true,
          "stock_verified": false,
          "supplier_variant_id": null,
          "views": {
            "front": {
              "verified": true,
              "view": "front",
              "source": "https://cdn11.bigcommerce.com/s-hsi95a83fz/images/stencil/500w/products/656/16062/1161_FRAME_TRUCKER_CAP_NAVY__05158.1747698655.jpg?c=1",
              "srcset": [
                {
                  "width": 500,
                  "url": "https://cdn11.bigcommerce.com/s-hsi95a83fz/images/stencil/500w/products/656/16062/1161_FRAME_TRUCKER_CAP_NAVY__05158.1747698655.jpg?c=1"
                },
                {
                  "width": 1000,
                  "url": "https://cdn11.bigcommerce.com/s-hsi95a83fz/images/stencil/1000w/products/656/16062/1161_FRAME_TRUCKER_CAP_NAVY__05158.1747698655.jpg?c=1"
                }
              ],
              "width": 500,
              "height": 500,
              "alt": "AS Colour 1161, Navy, straight-on front",
              "area_id": null,
              "usage_basis": "AS Colour public product-image resources; guidelines reviewed; no transfer of ownership"
            },
            "left": null,
            "right": null,
            "back": {
              "verified": true,
              "view": "back",
              "source": "https://cdn11.bigcommerce.com/s-hsi95a83fz/images/stencil/500w/products/656/16055/1161_FRAME_FOAM_TRUCKER_CAP_NAVY_BACK__83998.1747698655.jpg?c=1",
              "srcset": [
                {
                  "width": 500,
                  "url": "https://cdn11.bigcommerce.com/s-hsi95a83fz/images/stencil/500w/products/656/16055/1161_FRAME_FOAM_TRUCKER_CAP_NAVY_BACK__83998.1747698655.jpg?c=1"
                },
                {
                  "width": 1000,
                  "url": "https://cdn11.bigcommerce.com/s-hsi95a83fz/images/stencil/1000w/products/656/16055/1161_FRAME_FOAM_TRUCKER_CAP_NAVY_BACK__83998.1747698655.jpg?c=1"
                }
              ],
              "width": 500,
              "height": 500,
              "alt": "AS Colour 1161, Navy, rear view showing snapback closure",
              "area_id": null,
              "usage_basis": "AS Colour public product-image resources; guidelines reviewed; no transfer of ownership"
            }
          }
        }
      }
    },
    "foam_premium_twotone": {
      "style": "foam",
      "manufacturer": "AS Colour",
      "reference": "1163",
      "construction": "five-panel foam-front two-tone mesh-back trucker",
      "source_page": "https://ascolour.com/frame-foam-two-tone-trucker-1163/",
      "areas": {},
      "colors": {
        "white-black": {
          "name": "White / Black",
          "catalog_verified": true,
          "stock_verified": false,
          "supplier_variant_id": null,
          "views": {
            "front": {
              "verified": true,
              "view": "front",
              "source": "https://cdn11.bigcommerce.com/s-hsi95a83fz/images/stencil/500w/products/903/24538/1163_FRAME_FOAM_2-TONE_TRUCKER_WHITE_BLACK__35902.1765747274.jpg?c=1",
              "srcset": [
                {
                  "width": 500,
                  "url": "https://cdn11.bigcommerce.com/s-hsi95a83fz/images/stencil/500w/products/903/24538/1163_FRAME_FOAM_2-TONE_TRUCKER_WHITE_BLACK__35902.1765747274.jpg?c=1"
                },
                {
                  "width": 1000,
                  "url": "https://cdn11.bigcommerce.com/s-hsi95a83fz/images/stencil/1000w/products/903/24538/1163_FRAME_FOAM_2-TONE_TRUCKER_WHITE_BLACK__35902.1765747274.jpg?c=1"
                }
              ],
              "width": 500,
              "height": 500,
              "alt": "AS Colour 1163, White / Black, straight-on front",
              "area_id": null,
              "usage_basis": "AS Colour public product-image resources; guidelines reviewed; no transfer of ownership"
            },
            "left": null,
            "right": null,
            "back": {
              "verified": true,
              "view": "back",
              "source": "https://cdn11.bigcommerce.com/s-hsi95a83fz/images/stencil/500w/products/903/24543/1163_FRAME_FOAM_2-TONE_TRUCKER_WHITE_BLACK_BACK__79928.1765747275.jpg?c=1",
              "srcset": [
                {
                  "width": 500,
                  "url": "https://cdn11.bigcommerce.com/s-hsi95a83fz/images/stencil/500w/products/903/24543/1163_FRAME_FOAM_2-TONE_TRUCKER_WHITE_BLACK_BACK__79928.1765747275.jpg?c=1"
                },
                {
                  "width": 1000,
                  "url": "https://cdn11.bigcommerce.com/s-hsi95a83fz/images/stencil/1000w/products/903/24543/1163_FRAME_FOAM_2-TONE_TRUCKER_WHITE_BLACK_BACK__79928.1765747275.jpg?c=1"
                }
              ],
              "width": 500,
              "height": 500,
              "alt": "AS Colour 1163, White / Black, rear view showing snapback closure",
              "area_id": null,
              "usage_basis": "AS Colour public product-image resources; guidelines reviewed; no transfer of ownership"
            }
          }
        }
      }
    },
    "everyday_premium_solid": {
      "style": "everyday",
      "manufacturer": "AS Colour",
      "reference": "1160",
      "construction": "structured five-panel seamless front",
      "source_page": "https://ascolour.com/frame-cap-1160/",
      "areas": {},
      "colors": {
        "black": {
          "name": "Black",
          "catalog_verified": true,
          "stock_verified": false,
          "supplier_variant_id": null,
          "views": {
            "front": {
              "verified": true,
              "view": "front",
              "source": "https://cdn11.bigcommerce.com/s-hsi95a83fz/images/stencil/500w/products/655/16036/1160_FRAME_CAP_BLACK__94351.1753757238.jpg?c=1",
              "srcset": [
                {
                  "width": 500,
                  "url": "https://cdn11.bigcommerce.com/s-hsi95a83fz/images/stencil/500w/products/655/16036/1160_FRAME_CAP_BLACK__94351.1753757238.jpg?c=1"
                },
                {
                  "width": 1000,
                  "url": "https://cdn11.bigcommerce.com/s-hsi95a83fz/images/stencil/1000w/products/655/16036/1160_FRAME_CAP_BLACK__94351.1753757238.jpg?c=1"
                }
              ],
              "width": 500,
              "height": 500,
              "alt": "AS Colour 1160, Black, straight-on front",
              "area_id": null,
              "usage_basis": "AS Colour public product-image resources; guidelines reviewed; no transfer of ownership"
            },
            "left": null,
            "right": null,
            "back": {
              "verified": true,
              "view": "back",
              "source": "https://cdn11.bigcommerce.com/s-hsi95a83fz/images/stencil/500w/products/655/16041/1160_FRAME_CAP_BLACK_BACK__79790.1753757238.jpg?c=1",
              "srcset": [
                {
                  "width": 500,
                  "url": "https://cdn11.bigcommerce.com/s-hsi95a83fz/images/stencil/500w/products/655/16041/1160_FRAME_CAP_BLACK_BACK__79790.1753757238.jpg?c=1"
                },
                {
                  "width": 1000,
                  "url": "https://cdn11.bigcommerce.com/s-hsi95a83fz/images/stencil/1000w/products/655/16041/1160_FRAME_CAP_BLACK_BACK__79790.1753757238.jpg?c=1"
                }
              ],
              "width": 500,
              "height": 500,
              "alt": "AS Colour 1160, Black, rear view showing snapback closure",
              "area_id": null,
              "usage_basis": "AS Colour public product-image resources; guidelines reviewed; no transfer of ownership"
            }
          }
        },
        "navy": {
          "name": "Navy",
          "catalog_verified": true,
          "stock_verified": false,
          "supplier_variant_id": null,
          "views": {
            "front": {
              "verified": true,
              "view": "front",
              "source": "https://cdn11.bigcommerce.com/s-hsi95a83fz/images/stencil/500w/products/655/16045/1160_FRAME_CAP_NAVY__21127.1753757238.jpg?c=1",
              "srcset": [
                {
                  "width": 500,
                  "url": "https://cdn11.bigcommerce.com/s-hsi95a83fz/images/stencil/500w/products/655/16045/1160_FRAME_CAP_NAVY__21127.1753757238.jpg?c=1"
                },
                {
                  "width": 1000,
                  "url": "https://cdn11.bigcommerce.com/s-hsi95a83fz/images/stencil/1000w/products/655/16045/1160_FRAME_CAP_NAVY__21127.1753757238.jpg?c=1"
                }
              ],
              "width": 500,
              "height": 500,
              "alt": "AS Colour 1160, Navy, straight-on front",
              "area_id": null,
              "usage_basis": "AS Colour public product-image resources; guidelines reviewed; no transfer of ownership"
            },
            "left": null,
            "right": null,
            "back": {
              "verified": true,
              "view": "back",
              "source": "https://cdn11.bigcommerce.com/s-hsi95a83fz/images/stencil/500w/products/655/16042/1160_FRAME_CAP_NAVY_BACK__03489.1753757238.jpg?c=1",
              "srcset": [
                {
                  "width": 500,
                  "url": "https://cdn11.bigcommerce.com/s-hsi95a83fz/images/stencil/500w/products/655/16042/1160_FRAME_CAP_NAVY_BACK__03489.1753757238.jpg?c=1"
                },
                {
                  "width": 1000,
                  "url": "https://cdn11.bigcommerce.com/s-hsi95a83fz/images/stencil/1000w/products/655/16042/1160_FRAME_CAP_NAVY_BACK__03489.1753757238.jpg?c=1"
                }
              ],
              "width": 500,
              "height": 500,
              "alt": "AS Colour 1160, Navy, rear view showing snapback closure",
              "area_id": null,
              "usage_basis": "AS Colour public product-image resources; guidelines reviewed; no transfer of ownership"
            }
          }
        }
      }
    },
    "everyday_premium_twotone": {
      "style": "everyday",
      "manufacturer": "AS Colour",
      "reference": "1165",
      "construction": "structured five-panel seamless front two-tone",
      "source_page": "https://ascolour.com/frame-two-tone-cap-1165/",
      "areas": {},
      "colors": {
        "natural-midnight": {
          "name": "Natural / Midnight",
          "catalog_verified": true,
          "stock_verified": false,
          "supplier_variant_id": null,
          "views": {
            "front": {
              "verified": true,
              "view": "front",
              "source": "https://cdn11.bigcommerce.com/s-hsi95a83fz/images/stencil/500w/products/1072/20950/1165_FRAME_TWO-TONE_CAP_NATURAL_MIDNIGHT__67365.1742762785.jpg?c=1",
              "srcset": [
                {
                  "width": 500,
                  "url": "https://cdn11.bigcommerce.com/s-hsi95a83fz/images/stencil/500w/products/1072/20950/1165_FRAME_TWO-TONE_CAP_NATURAL_MIDNIGHT__67365.1742762785.jpg?c=1"
                },
                {
                  "width": 1000,
                  "url": "https://cdn11.bigcommerce.com/s-hsi95a83fz/images/stencil/1000w/products/1072/20950/1165_FRAME_TWO-TONE_CAP_NATURAL_MIDNIGHT__67365.1742762785.jpg?c=1"
                }
              ],
              "width": 500,
              "height": 500,
              "alt": "AS Colour 1165, Natural / Midnight, straight-on front",
              "area_id": null,
              "usage_basis": "AS Colour public product-image resources; guidelines reviewed; no transfer of ownership"
            },
            "left": null,
            "right": null,
            "back": {
              "verified": true,
              "view": "back",
              "source": "https://cdn11.bigcommerce.com/s-hsi95a83fz/images/stencil/500w/products/1072/20951/1165_FRAME_TWO-TONE_CAP_NATURAL_MIDNIGHT_BACK__76758.1742762785.jpg?c=1",
              "srcset": [
                {
                  "width": 500,
                  "url": "https://cdn11.bigcommerce.com/s-hsi95a83fz/images/stencil/500w/products/1072/20951/1165_FRAME_TWO-TONE_CAP_NATURAL_MIDNIGHT_BACK__76758.1742762785.jpg?c=1"
                },
                {
                  "width": 1000,
                  "url": "https://cdn11.bigcommerce.com/s-hsi95a83fz/images/stencil/1000w/products/1072/20951/1165_FRAME_TWO-TONE_CAP_NATURAL_MIDNIGHT_BACK__76758.1742762785.jpg?c=1"
                }
              ],
              "width": 500,
              "height": 500,
              "alt": "AS Colour 1165, Natural / Midnight, rear view showing snapback closure",
              "area_id": null,
              "usage_basis": "AS Colour public product-image resources; guidelines reviewed; no transfer of ownership"
            }
          }
        }
      }
    },
    "performance_standard": {
      "style": "performance",
      "manufacturer": "OTTO CAP",
      "reference": "120",
      "construction": "five-panel perforated performance",
      "source_page": null,
      "areas": {},
      "colors": {}
    },
    "performance_premium": {
      "style": "performance",
      "manufacturer": "Zapped Headwear",
      "reference": "",
      "construction": "Blackhawk five-panel perforated performance",
      "source_page": null,
      "areas": {},
      "colors": {}
    },
    "foam_standard": {
      "style": "foam",
      "manufacturer": "OTTO CAP",
      "reference": "",
      "construction": "foam-front model unresolved",
      "source_page": null,
      "areas": {},
      "colors": {}
    },
    "everyday_standard": {
      "style": "everyday",
      "manufacturer": "OTTO CAP",
      "reference": "31-069",
      "construction": "structured five-panel seamless front",
      "source_page": null,
      "areas": {},
      "colors": {}
    },
    "dad_standard": {
      "style": "dad",
      "manufacturer": "Supplier pending confirmation",
      "reference": "",
      "construction": "soft six-panel with center seam; supplier unresolved",
      "source_page": null,
      "areas": {},
      "colors": {}
    },
    "dad_premium": {
      "style": "dad",
      "manufacturer": "Supplier pending confirmation",
      "reference": "",
      "construction": "soft six-panel with center seam; supplier unresolved",
      "source_page": null,
      "areas": {},
      "colors": {}
    }
  }
};
const finite=n=>typeof n==='number'&&Number.isFinite(n);
function modelMap(model,override){
 const candidate=override&&Object.keys(override).length?override:catalog.models[model?.key];
 if(!candidate||candidate.style!==model?.style||candidate.manufacturer!==model?.manufacturer||String(candidate.reference)!==String(model?.reference))return null;
 return candidate;
}
function resolve(model,colorId,view,override){
 const mapped=modelMap(model,override),color=mapped?.colors?.[colorId],photo=color?.views?.[view];
 const available=!!(color?.catalog_verified===true&&photo?.verified===true&&photo.view===view&&/^https:\/\//.test(photo.source||'')&&finite(photo.width)&&finite(photo.height)&&photo.width>0&&photo.height>0);
 const area=available?mapped.areas?.[photo.area_id]:null,r=area?.rect;
 const areaApproved=!!(area?.approved===true&&typeof area.id==='string'&&area.id.length>0&&area.location===view&&area.id===photo.area_id&&r&&['x','y','width','height'].every(k=>finite(r[k]))&&r.x>=0&&r.y>=0&&r.width>0&&r.height>0&&r.x+r.width<=100&&r.y+r.height<=100&&finite(area.width_mm)&&finite(area.height_mm)&&area.width_mm>0&&area.height_mm>0&&typeof area.version==='string'&&area.version);
 return{mapped,color,photo:available?photo:null,area:areaApproved?area:null,available,editable:available&&areaApproved};
}
function clampPose(p){const size=Math.min(100,Math.max(10,finite(p.size)?p.size:50));return{size,x:Math.min(100-size,Math.max(0,finite(p.x)?p.x:25)),y:Math.min(100-size,Math.max(0,finite(p.y)?p.y:25))};}
function compatibleAreas(a,b){return !!(a?.approved&&b?.approved&&a.compatibility_group&&a.compatibility_group===b.compatibility_group&&a.location===b.location&&a.width_mm===b.width_mm&&a.height_mm===b.height_mm);}
const api={catalog,modelMap,resolve,clampPose,compatibleAreas};
if(typeof module==='object'&&module.exports)module.exports=api;else scope.WavesHeadwearPhotography=api;
})(typeof window==='undefined'?{}:window);
